import usePermission from '../../../hook/usePermission'
import {MatrixReportPageContext} from '../context'
import useGetMatrixData from '../hooks/MatrixReport/useGetMatrixData'
import MatrixHeader from '../sections/headers/MatrixHeader'
import MatrixTable from '../sections/tables/matrixReport/MatrixTable'

const Matrix = () => {
  const {hasPermission} = usePermission()
  const hasProjectSettingsPermission = hasPermission('projects_settings', 'write')

  const {
    isLoading: isLoadingMatrixData,
    xAxisMatrixData,
    yAxisMatrixData,
    onSearch,
    filters,
    searchValue,
    onSortingChange,
    onProjectChange,
    onXAxisChange,
    onYAxisChange,
    onBothChange,
  } = useGetMatrixData()

  const contextValue = {
    hasProjectSettingsPermission,
    isLoadingMatrixData,
    xAxisMatrixData,
    yAxisMatrixData,
    onSortingChange,
    onSearch,
    searchValue,
    filters,
    onProjectChange,
    onXAxisChange,
    onYAxisChange,
    onBothChange,
  }

  return (
    <MatrixReportPageContext.Provider value={contextValue}>
      <MatrixHeader />
      <MatrixTable />
    </MatrixReportPageContext.Provider>
  )
}

export default Matrix
